import { Collapse, TableCell, TableRow, Typography } from "@mui/material";
import HeiSelection from "../HeiSelection/HeiSelection";
import * as React from "react";
import { UseFormReturn } from "react-hook-form";
import { ProjectFormType } from "../../hooks/useCreateProject";
import ToolAccess from "../ToolAccess/ToolAccess";
import { getRolesForPackageData } from "../../hooks/useRolesForSelect";

interface ProjectUserDetailsFieldsTableRowProps {
  userOpen: boolean;
  index: number;
  isEdit?: boolean;
  userCanEdit: boolean;
  form: UseFormReturn<ProjectFormType>;
  useCustomRoleMapping: boolean;
  isCreateMode?: boolean;
}

const ProjectUserDetailsFieldsTableRow = ({
  userOpen,
  index,
  isEdit, // eslint-disable-line @typescript-eslint/no-unused-vars
  userCanEdit,
  form,
  useCustomRoleMapping,
  isCreateMode = false,
}: ProjectUserDetailsFieldsTableRowProps): JSX.Element => {
  const { control, getValues } = form;

  const accessTools = getValues(`users.${index}.toolCaps`);
  const rolesForSelect = getRolesForPackageData(useCustomRoleMapping);


  const toolsToDisplay = isCreateMode 
    ? accessTools?.filter(tool => tool.hasAccess) 
    : accessTools;

  return (
    <TableRow sx={{ background: "#f5f5f5" }}>
      <TableCell
        style={{ paddingBottom: 0, paddingTop: 0, verticalAlign: "top" }}
        colSpan={2}
      >
        <Collapse in={userOpen} unmountOnExit>
          <div style={{ padding: "8px" }}>
            <Typography variant="body2" sx={{ color: "#202020", mb: 1, mt: 1 }}>
              Select role
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Select the role(s) for this user. Read details about roles.
            </Typography>
            <HeiSelection
              control={control}
              fieldName={`users.${index}.roles`}
              disabled={!userCanEdit}
              getValues={getValues}
              options={rolesForSelect}
              label={"Roles"}
              multiple={true}
              rules={{
                required: "Please select at least 1 role for this user.",
                // validate: (value: string[] | any) =>
                //   roleValidator(value, getValues("users"), packageId),
              }}
            />
          </div>
        </Collapse>
      </TableCell>
      <TableCell
        style={{ paddingBottom: 0, paddingTop: 0, verticalAlign: "top" }}
        colSpan={4}
      >
        <Collapse in={userOpen} unmountOnExit>
          <div style={{ padding: "8px" }}>
            <Typography variant="body2" sx={{ color: "#202020", mb: 1, mt: 1 }}>
              Set tool access
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Select a tool to send an invite to this user or deselect a tool to
              revoke access.
            </Typography>
            {toolsToDisplay?.map((st, i) => {
 
              const toolIndex = isCreateMode 
                ? accessTools?.findIndex(tool => tool.toolId === st.toolId) ?? i
                : i;
              
              return (
                <ToolAccess
                  key={i}
                  tool={st}
                  toolIndex={toolIndex}
                  userIndex={index}
                  form={form}
                  userCanEdit={userCanEdit}
                  isCreateMode={isCreateMode}
                />
              );
            })}
          </div>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default ProjectUserDetailsFieldsTableRow;
